var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpendocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M10.125,7.5h-.75A.375.375,0,0,0,9,7.875V10.5H1.5V3H4.875a.375.375,0,0,0,.375-.375v-.75A.375.375,0,0,0,4.875,1.5H1.125A1.125,1.125,0,0,0,0,2.625v8.25A1.125,1.125,0,0,0,1.125,12h8.25A1.125,1.125,0,0,0,10.5,10.875v-3a.375.375,0,0,0-.375-.375ZM11.438,0h-3a.564.564,0,0,0-.4.961l.837.837L3.164,7.509a.563.563,0,0,0,0,.8l.531.53a.563.563,0,0,0,.8,0L10.2,3.125l.837.836a.563.563,0,0,0,.961-.4v-3A.563.563,0,0,0,11.438,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpendocument);
export default __webpack_public_path__ + "static/media/opendocument.d6b72023001927c0af0bee4a761f7615.svg";
export { ForwardRef as ReactComponent };